module.exports = __webpack_public_path__ + "static/img/game-level2.2003e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-level2.png
// module id = hYX8
// module chunks = 1